<template>
    <Modal id="upgrade-needed" :show-footer="false" :show-title="false" @cancel="cancel">
        <div class="upgrade-needed-content">
            <div class="upgrade-needed-content-title">
                <UpgradeIconSvg />
                <div>{{ $t("message.upgradePackageTitle") }}</div>
            </div>
            <div class="upgrade-needed-content-description">
                <template v-if="descriptions[upgradeDetail.name]">
                    {{ descriptions[upgradeDetail.name] }}
                </template>
                <template v-else>
                    {{ $t("message.moreFeaturesDesc") }}
                </template>
            </div>
            <div class="upgrade-needed-content-content">
                <UpgradeSVG />
            </div>
            <div class="upgrade-needed-content-footer">
                <SupsisButton @click="upgrade" primary>{{ $t("message.upgradePackage") }}</SupsisButton>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import UpgradeSVG from "../svg/Upgrade.vue";
import UpgradeIconSvg from "./svg/UpgradeIconSvg.vue";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";
import { mapState } from "vuex";

export default {
    name: "UpgradeNeeded",
    props: {
        plan: {
            type: String,
            default: null,
        },
    },
    components: {
        SupsisButton,
        UpgradeIconSvg,
        Modal,
        UpgradeSVG,
    },
    computed: {
        ...mapState({
            upgradeDetail: (state) => state.app.upgrade,
        }),
    },
    data: function () {
        return {
            descriptions: {
                maxAgentCount: this.$t("upgradeMessages.maxAgentCount"),
                maxTriggerCount: this.$t("upgradeMessages.maxTriggerCount"),
                visitorStartChat: this.$t("upgradeMessages.visitorStartChat"),
                voiceCalling: this.$t("upgradeMessages.voiceCalling"),
                videoCalling: this.$t("upgradeMessages.videoCalling"),
                fileAndVoiceMessage: this.$t("upgradeMessages.fileAndVoiceMessage"),
                autoTranslation: this.$t("upgradeMessages.autoTranslation"),
                telegramEntegration: this.$t("upgradeMessages.telegramEntegration"),
                chatCopilot: this.$t("upgradeMessages.chatCopilot"),
                calenderEntegration: this.$t("upgradeMessages.calenderEntegration"),
                mailEntegration: this.$t("upgradeMessages.mailEntegration"),
                smsEntegration: this.$t("upgradeMessages.smsEntegration"),
                ticketSystem: this.$t("upgradeMessages.ticketSystem"),
                taskManagementEntegration: this.$t("upgradeMessages.taskManagementEntegration"),
                webhookEntegration: this.$t("upgradeMessages.webhookEntegration"),
                readyContents: this.$t("upgradeMessages.readyContents"),
                automationEntegration: this.$t("upgradeMessages.automationEntegration"),
                customerTablesEntegration: this.$t("upgradeMessages.customerTablesEntegration"),
                formEntegration: this.$t("upgradeMessages.formEntegration"),
                maxFormLimit: this.$t("upgradeMessages.maxFormLimit"),
                maxFormFieldLimit: this.$t("upgradeMessages.maxFormFieldLimit"),
                maxCustomerTableCount: this.$t("upgradeMessages.maxCustomerTableCount"),
                maxCustomerTableFieldCount: this.$t("upgradeMessages.maxCustomerTableFieldCount"),
                maxCustomerTableViewCount: this.$t("upgradeMessages.maxCustomerTableViewCount"),
                maxCustomerTableRecordCount: this.$t("upgradeMessages.maxCustomerTableRecordCount"),
                maxAutomationButton: this.$t("upgradeMessages.maxAutomationButton"),
                automationTimerBase: this.$t("upgradeMessages.automationTimerBase"),
                automationEventBase: this.$t("upgradeMessages.automationEventBase"),
                automationWebhookBase: this.$t("upgradeMessages.automationWebhookBase"),
                automationButtonBase: this.$t("upgradeMessages.automationButtonBase"),
                liveScore: this.$t("upgradeMessages.liveScore"),
                multipleChatWindow: this.$t("upgradeMessages.multipleChatWindow"),
                maxTaskWorkflowLimit: this.$t("upgradeMessages.maxTaskWorkflowLimit"),
                maxTaskColumnLimit: this.$t("upgradeMessages.maxTaskColumnLimit"),
                maxTaskRowLimit: this.$t("upgradeMessages.maxTaskRowLimit"),
                maxDepartmentLimit: this.$t("upgradeMessages.maxDepartmentLimit"),
                maxRoleLimit: this.$t("upgradeMessages.maxRoleLimit"),
                maxReadyContentsLimit: this.$t("upgradeMessages.maxReadyContentsLimit"),
                excelDownload: this.$t("upgradeMessages.excelDownload"),
                customerGroup: this.$t("upgradeMessages.customerGroup"),
                maxMailCount: this.$t("upgradeMessages.maxMailCount"),
                maxWhatsappChannel: this.$t("upgradeMessages.maxWhatsappChannel"),
                maxBusinessWhatsappChannel: this.$t("upgradeMessages.maxBusinessWhatsappChannel"),
                maxInstagramChannel: this.$t("upgradeMessages.maxInstagramChannel"),
                maxMessengerChannel: this.$t("upgradeMessages.maxMessengerChannel"),
                maxTelegramChannel: this.$t("upgradeMessages.maxTelegramChannel"),
                maxTrendyolChannel: this.$t("upgradeMessages.maxTrendyolChannel"),
                maxMetaLeadChannel: this.$t("upgradeMessages.maxMetaLeadChannel"),
            }
        };
    },
    methods: {
        cancel() {
            this.$emit("close");
        },
        upgrade() {
            this.$router.push(`/billing/plans/${this.plan}`);
            this.cancel();
        },
    },
};
</script>
<style lang="scss">
#upgrade-needed {
    .ant-modal {
        width: max-content !important;
    }

    .ant-modal-content {
        box-shadow: none;
    }

    .ant-modal-mask {
        background-color: rgba(0, 0, 0, 0.6) !important;
    }

    .upgrade-needed-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &-title {
            svg {
                width: 40px;
                height: 40px;
            }

            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 20px;
            font-weight: bold;
        }

        &-description {
            text-align: center;
            width: 600px;
            font-size: 18px;
        }

        &-content {
            width: 300px;
            margin-top: 20px;
            margin-bottom: 20px;

            svg {
                width: 100%;
                height: 100%;
            }
        }

        &-footer {
            .supsis-button {
                min-width: 280px;
            }
        }
    }
}
</style>
